import { combineReducers } from 'redux'
import search from './search.reducer'
import tags from './tags.reducer'

export default combineReducers({
  search,
  tags
})
